import { render, staticRenderFns } from "./addJurisdiction.vue?vue&type=template&id=447edcb3&scoped=true&"
import script from "./addJurisdiction.vue?vue&type=script&lang=js&"
export * from "./addJurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./addJurisdiction.vue?vue&type=style&index=0&id=447edcb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447edcb3",
  null
  
)

export default component.exports